// extracted by css-extract-rspack-plugin
export default {"cls1":"after_click_map-cls1_EFC","cls2":"after_click_map-cls2_PTP after_click_map-cls1_EFC"};